import { SLACK_COLUMN_ID } from "../constants";
import SlackTableDropdownActionsCell from "./DropdownActionsCell";
import SlackTableNameCell from "./NameCell";
import SlackTableSlackIdCell from "./SlackIdCell";
import SlackTableSpacesCell from "./SpacesCell";

export const SLACK_TABLE_CELLS = {
  [SLACK_COLUMN_ID.NAME]: SlackTableNameCell,
  [SLACK_COLUMN_ID.SLACK_ID]: SlackTableSlackIdCell,
  [SLACK_COLUMN_ID.SPACES]: SlackTableSpacesCell,
  [SLACK_COLUMN_ID.DROPDOWN]: SlackTableDropdownActionsCell,
};
